
import gql from 'graphql-tag'

// 查询经销商by areaId
export const findDealersByAreaId = gql`
  query($areaId: Int!) {
    findDealersByAreaId(
      areaId: $areaId,
    ) {
      id
      realname
      storeName
      areas {
        id
        name
        mergerName
      }
    }
  }
`
// """查询经销商"""
export const findDealer = gql`
  query($dealerId: Int!) {
    findDealer(
      dealerId: $dealerId,
    ) {
      address
      denyReason
      openId
      areas {
        cityCode
        createdAt
        id
        ing
        lat
        levelType
        managers {
          createdBy {
            id
            username
          }
          modifiedBy {
            id
            username
          }
        }
        mergerName
        name
        parentId
        pinyin
        shortName
        updatedAt
        zipCode
      }
      covers
      auditDate
      applyDate
      createdAt
      goodRelations {
        details
        price
        goodId
        sharingProportion
        good {
          id
          title
          isbn
          author
          status
          press
          thumb
          price
          details
        }
      }
      sharingProportion
      id
      ifStoreOpening
      level
      managers {
        createdBy {
          id
          username
        }
        modifiedBy {
          id
          username
        }
      }
      parentId
      profilePhoto
      realname
      schools {
        id
        name
        area {
          mergerName
        }
      }
      status
      storeName
      storePhone
      updatedAt
      user {
        id
        role
        username
        phone
        email
      }
      userId
    }
  }
`

// """查询经销商列表"""
export const findDealers = gql`
  query($order: [DealersFindOrder!], $paging: PagingQuery, $where: DealersFindFilter) {
    findDealers(
      order: $order,
      paging: $paging,
      where: $where,
    ) {
      dealers {
        address
        denyReason
        openId
        areas {
          cityCode
          createdAt
          id
          ing
          lat
          levelType
          managers {
            createdBy {
              id
              username
            }
            modifiedBy {
              id
              username
            }
          }
          mergerName
          name
          parentId
          pinyin
          shortName
          updatedAt
          zipCode
        }
        covers
        auditDate
        applyDate
        createdAt
        id
        ifStoreOpening
        level
        managers {
          createdBy {
            id
            username
          }
          modifiedBy {
            id
            username
          }
        }
        parentId
        profilePhoto
        realname
        schools {
          id
          name
          area {
            mergerName
          }
        }
        status
        storeName
        storePhone
        updatedAt
        user {
          id
          role
          username
          phone
          email
        }
        userId
      }
      paging {
        currentOffset
        take
        totalCount
      }
    }
  }
`

// """审核经销商"""
export const auditDealer = gql`
  mutation($dealerId: Int!, $status: AuditStatus!, $denyReason: String) {
    auditDealer(
      dealerId: $dealerId,
      status: $status,
      denyReason: $denyReason
    )
  }
`

// """删除经销商"""

export const deleteDealer = gql`
  mutation($dealerId: Int!) {
    deleteDealer(
      dealerId: $dealerId
    )
  }
`

export const exportDealersList = gql`
  query($order: [DealersFindOrder!],$where: DealersFindFilter) {
    exportDealersList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`
